<template>
  <div v-if="filteredPlaylists.length" class="sonar-section__container">
    <div class="sonar-section__header">
      <div class="sonar-section__title-wrapper">
        <h5 class="sonar-section__title">Assigned playlists</h5>
        <h6 class="sonar-section__subtitle">
          These playlists evolve with Skill Sonar assessment results.
        </h6>
      </div>
    </div>
    <div class="sonar-section__body">
      <div v-if="isLoading" class="sonar-playlists__wrapper">
        <ActionLoader :size="1" class="sonar-playlists__loader" />
      </div>
      <div v-else class="sonar-playlists__wrapper">
        <Playlist
          v-for="playlist of filteredPlaylists"
          :key="playlist.id"
          class="sonar-playlists__item"
          :playlist="playlist"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Playlist from '@/components/playlists/Playlist.vue'
import ActionLoader from '@/components/shared/ActionLoader.vue'

export default {
  name: 'SonarPlaylist',
  components: {
    Playlist,
    ActionLoader,
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    filteredPlaylists: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.sonar-playlists {
  &__wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }
  &__item {
    flex: 1 1 400px;
    @include mobile {
      flex: 0 1 400px;
    }
  }
  &__loader {
    margin: 0 auto;
  }
}
</style>
